// extracted by mini-css-extract-plugin
export default {"footer_wrapper":"Footer_footer_wrapper__LgyeP","footer_icon":"Footer_footer_icon__lVYNB","footer_link":"Footer_footer_link__86o3V"};